import React from 'react';
import { Icon, IconProps } from '@chakra-ui/react';

const ChatIcon = (props: IconProps) => {
  return (
    <Icon
      enableBackground="new 0 0 24 24"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_2244_1903)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12 0C5.4 0 0 4.77333 0 10.6667C0 13.5067 1.26 16.0933 3.3 18C3.24 18.8 2.796 20.8933 0 24C0 24 4.26 24 7.764 20.6667C9.084 21.0933 10.512 21.3333 12 21.3333C18.6 21.3333 24 16.56 24 10.6667C24 4.77333 18.6 0 12 0ZM15.2 16V14.4C15.2 14.4 15.2 11.2 9.6 11.2C4 11.2 4 14.4 4 14.4V16H15.2ZM11.9281 5.24444C12.2358 5.7049 12.4 6.24625 12.4 6.80003C12.4 7.54264 12.105 8.25482 11.5799 8.77992C11.0548 9.30502 10.3426 9.60002 9.6 9.60002C9.04621 9.60002 8.50486 9.43581 8.0444 9.12814C7.58395 8.82047 7.22506 8.38317 7.01314 7.87154C6.80121 7.35991 6.74576 6.79693 6.8538 6.25378C6.96184 5.71064 7.22851 5.21173 7.6201 4.82014C8.01169 4.42855 8.5106 4.16188 9.05375 4.05384C9.59689 3.94581 10.1599 4.00125 10.6715 4.21318C11.1831 4.4251 11.6204 4.78399 11.9281 5.24444ZM16.3309 12.6172C16.0462 12.0644 15.6438 11.5806 15.152 11.2C20 11.496 20 14.4 20 14.4V16H16.8V14.4C16.7758 13.7786 16.6157 13.1701 16.3309 12.6172ZM12.856 4.47204C13.3108 4.16161 13.8493 3.99698 14.4 4.00004C15.1426 4.00004 15.8548 4.29504 16.3799 4.82014C16.905 5.34524 17.2 6.05743 17.2 6.80003C17.2 7.54264 16.905 8.25482 16.3799 8.77992C15.8548 9.30502 15.1426 9.60002 14.4 9.60002C13.8493 9.60309 13.3108 9.43846 12.856 9.12802C13.342 8.44904 13.6032 7.635 13.6032 6.80003C13.6032 5.96506 13.342 5.15103 12.856 4.47204Z"
            fill="white"
          />
        </g>
        <defs>
          <clipPath id="clip0_2244_1903">
            <rect width="24" height="24" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </Icon>
  );
};

export default ChatIcon;
